import "./cardForo.css";
import DeletePost from "../deletePost/deletePost";
import timeDate from "../../../../utilities/timeDate";

const CardForo = (props) => {
  const data = props.data;
  const {
    date,
    current_date,
    id,
    link,
    title,
    excerpt,
    author,
    foroTags,
  } = data;

  const htmlLang = document.documentElement.lang;
  const baseUrl = link.split(".org")[0] + ".org";
  const urlPath = new URL(link);
  const pathAfterDomain = urlPath.pathname;

  const isLangEnUS = htmlLang === "en-US";

  const finalLink = isLangEnUS
    ? `${baseUrl}/en${pathAfterDomain}`
    : `${baseUrl}${pathAfterDomain}`;

  return (
    <div className="c-card-foro" data-post-id={id}>
      <DeletePost postId={id} author={author.author_id} />
      <div className="c-card-foro__content">
        <a href={finalLink} className="c-card-foro__anchor">
          <div className="c-card-foro__head">
            <img
              className="c-card-foro__avatar"
              src={author.avatar}
              alt={author.name}
            />
            <div className="c-card-foro___name-time">
              <h3 className="c-card-foro__name">{author.name}</h3>
              <span className="c-card-foro__time">
                {timeDate(date, current_date)}
              </span>
            </div>
          </div>
          <div className="c-card-foro__body">
            <h3 className="c-card-foro__title">{title}</h3>
            <p className="c-card-foro__excerpt">
              {excerpt.replace(/&hellip;/g, "...")}
            </p>
          </div>
        </a>
        {foroTags && (
          <div className="c-card-foro__footer">
            {foroTags.map((tags) => {
              const { term_id, name } = tags;
              return (
                <span className="c-card-foro__tag" key={term_id}>
                  {name}
                </span>
              );
            })}
          </div>
        )}
      </div>
    </div>
  );
};

export default CardForo;
